const partials = {};

const handlebarPartials = import.meta.glob(["@/handlebars/**/*.hbs", "!@/handlebars/partials/env-*/**/*.hbs", "!@/handlebars/partials/tb-*/**/*.hbs"], { import: "default", eager: true });
for (const key in handlebarPartials) {
  const partialName = key.match(/src\/handlebars\/(.*).hbs$/)[1];
  partials[partialName] = handlebarPartials[key];
}

export default partials;
